<p-toast position='bottom-right'></p-toast>
<div class='mb-3'>
  <p-button (onClick)='previousPage()' [disabled]='isFirstPage$ | async' icon='pi pi-chevron-left' styleClass='p-button-text'
            type='button'></p-button>
  <p-button (onClick)='nextPage()' [disabled]='isLastPage$ | async' icon='pi pi-chevron-right' styleClass='p-button-text'
            type='button'></p-button>
</div>

<p-table *ngIf='userNotificationTriggers$ | async as triggers' [columns]='cols$ | async'
         [loading]='loading' [rows]='pageSize$ | async' [totalRecords]='totalItems$ | async'
         [value]='triggers' responsiveLayout='scroll'>
  <ng-template let-columns pTemplate='header'>
    <tr>
      <th *ngFor='let col of columns'>
        {{col.header}}
      </th>
    </tr>
  </ng-template>
  <ng-template let-columns='columns' let-rowData pTemplate='body'>
    <tr>
      <td *ngFor='let col of columns'>
        <ng-container *ngIf="col.type === 'user' ">
          {{rowData[col.field].firstName}} {{rowData[col.field].surname}}
        </ng-container>
        <div *ngIf="col.type === 'nt'">
          <!-- disabled if trigger is on an entity level and we're editing on a location or target level. Just keeps things simple for now. -->
          <ng-container [ngTemplateOutletContext]='{rowData: rowData, col: col}'
                        [ngTemplateOutlet]='(locationId != null &&
                  !!rowData[col.field][col.value] &&
                  !rowData[col.field][col.value].location) ||
                  (targetId != null &&
                  !!rowData[col.field][col.value] &&
                  !rowData[col.field][col.value]?.targetId) ? disabledCheckbox : enabledCheckbox'></ng-container>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-template #enabledCheckbox let-col='col' let-rowData='rowData'>
  <input (change)="onChange($event, rowData['user'].id, col.value, rowData[col.field][col.value]?.id)"
         [checked]='!!rowData[col.field][col.value]'
         class='p-checkbox'
         type='checkbox'>
</ng-template>

<ng-template #disabledCheckbox let-col='col' let-rowData='rowData'>
  <div pTooltip='This trigger is enabled for the entity. Unable to edit per location' style='display: inline-block'>
    <input [checked]='!!rowData[col.field][col.value]'
           [disabled]='true'
           class='p-checkbox'
           type='checkbox'>
  </div>
</ng-template>
